var map = {
	"./alibaba-cloud.png": "5a57",
	"./apisfirst.png": "8820",
	"./auth0.png": "519e",
	"./daops.png": "817c",
	"./forgerock.png": "dfbd",
	"./ibm.png": "d82fc",
	"./nginx.png": "bbd4",
	"./wia.png": "a9a2",
	"./wso2.png": "4b20"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d872";